var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--secondary-orange-200)",
    width: 54,
    height: 54,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F58220",
    width: 31.5,
    height: 31.5,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.43 6.563c.483 0 .875.391.875.875v1.42h6.89v-1.42c0-.484.392-.875.875-.875h3.992c.484 0 .875.391.875.875v3.992a.875.875 0 01-.875.875H22.64v6.89h1.422c.484 0 .875.392.875.875v3.992a.875.875 0 01-.875.875H20.07a.875.875 0 01-.875-.875V22.64h-6.89v1.422a.875.875 0 01-.875.875H7.437a.875.875 0 01-.875-.875V20.07c0-.483.392-.875.875-.875h1.421v-6.89h-1.42a.875.875 0 01-.876-.875V7.437c0-.483.392-.875.875-.875h3.993zm7.765 4.867v-1.422h-6.89v1.422a.875.875 0 01-.875.875h-1.423v6.89h1.423c.483 0 .875.392.875.875v1.421h6.89v-1.42c0-.484.392-.876.875-.876h1.421v-6.89h-1.42a.875.875 0 01-.876-.875z",
    fill: "#FFFFFC"
  })))));
}
export default SvgProcess;